// ======================= Imports =======================
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.css";
import store from "./app/store/store";
import { StripeProvider } from "./providers/StripeProviders";
// import ErrorBoundaryWrapper from "./providers/ErrorBounrdyProvider";

// ======================= React Root Setup =======================
const root = ReactDOM.createRoot(document.getElementById("root"));

// ======================= App Rendering =======================
root.render(
  <Router>
    <Provider store={store}>
      <StripeProvider>
        <App />
      </StripeProvider>
    </Provider>
  </Router>
);
